import {isExternal, isWithoutRegistration} from '@wix/wix-events-commons-statics'
import {isEditor} from '../../../../commons/selectors/environment'
import {State} from '../types'
import {getEvent, hasGuestsGoing} from './event'

export const isMembersVisible = (state: State) => !isExternal(getEvent(state)) && state.membersAreaEnabled

export const isMembersVisibleWithGuests = (state: State) =>
  isMembersVisible(state) && (hasGuestsGoing(state) || isEditor(state)) && !isWithoutRegistration(getEvent(state))
